import CircularProgress from '@material-ui/core/CircularProgress';
import { useAppContext } from '../context/app.state';

const AppLoading = () => {
  const appContext = useAppContext();
  const { state } = appContext;
  const { appLoading } = state;

  return appLoading ? (
    <CircularProgress
      color="secondary"
      style={{
        position: 'absolute',
        top: 20,
        right: 20,
      }}
    />
  ) : <div />;
};

export default AppLoading;
